import { createFileRoute, Navigate } from "@tanstack/react-router";

import { useProcurementRuntime } from "../runtime/procurement-runtime";
import { ProviderSignInRedirect } from "../screens/procurement-shell";

const ProcurementRoute = () => {
  const { isAuthenticated, isLoading } = useProcurementRuntime().auth;

  if (isLoading || !isAuthenticated) return <ProviderSignInRedirect />;
  return <Navigate to="/demand-groups" replace />;
};

export const Route = createFileRoute("/")({ component: ProcurementRoute });
